define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/query",
	"csi/heading/stateColorResolver",
	"csi/html",
	"csi/html/StateWidget",
	"csi/locale",
	"csi/xml"
], function(declare,domClass,query,stateColorResolver,html,StateWidget,locale,xml) {

return declare(StateWidget, {
		_processHtml: function(/*Context*/ctx, /*DOMNode*/dom) {
			// summary: process each element with a key according to its matching definition
			this.inherited(arguments);
			
			var node = ctx.getNode();
			var eComplete = query(".complete", dom)[0];
			var eCompletedArchiveDPs = query(".completedArchiveDPs", dom)[0];
			var eCompletedArchivePDFs = query(".completedArchivePDFs", dom)[0];
			var eMarkedArchived = query(".markedArchived", dom)[0];
			
			const css = stateColorResolver.getStateCss(node);
			const stateEnumValue = xml.enumGetText(node.Status);
			
			switch (stateEnumValue) {
				case "Complete":  domClass.add(eComplete, css); break;
				case "CompletedArchiveDPs": domClass.add(eCompletedArchiveDPs, css); break;
				case "CompletedArchivePDFs": domClass.add(eCompletedArchivePDFs, css); break;
				case "MarkedArchived": domClass.add(eMarkedArchived, css); break;
			}

			html.text(eComplete, locale.getEnumName("SeasonStatus:Complete", true));
			html.text(eCompletedArchiveDPs, locale.getEnumName("SeasonStatus:CompletedArchiveDPs", true));
			html.text(eCompletedArchivePDFs, locale.getEnumName("SeasonStatus:CompletedArchivePDFs", true));
			html.text(eMarkedArchived, locale.getEnumName("SeasonStatus:MarkedArchived", true));
		}
	});
});